import { Component, ElementRef, ViewChild, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { AddressPart } from '@shared/models';
import { FormFieldComponent } from '../form-field.types';
import { ResearchService } from '@modules/research/research.service';

@Component({
  templateUrl: './text-form-field.component.html',
  styleUrls: ['./../form-field.component.scss'],
})
export class TextFormFieldComponent extends FormFieldComponent {
  @ViewChild('inputControl') inputControl: ElementRef;

  private _originalValue: string;

  public editing: boolean = false;
  public value: string;

  constructor(
    private readonly destroyRef: DestroyRef,
    private readonly resarchService: ResearchService,
  ) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.value = this.fieldDef.meta?.value_hidden ? 'REDACTED' : this.model[this.fieldDef.name];

    this._originalValue = this.value;

    this.updateMask();
  }

  edit(): void {
    if (!this.editing && !this.isReadonly) {
      this.editing = true;
      setTimeout(() => {
        this.inputControl?.nativeElement?.focus?.();
      }, 300);
    }
  }

  onBlur(): void {
    this.onSave();
    this.editing = false;
  }

  onSetAddress(event: AddressPart): void {
    if (event?.lat && event.lng) {
      const { lat, lng } = event;
      this.resarchService
        .reverseGeocode(null, lat, lng)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((response) => {
          if (response && response.address) {
            this.updateModel();
            this.update.emit({
              [this.fieldDef.name]: response.address,
              address: response,
            });
          }
        });
    }
  }

  onNgModelChange(): void {
    this.updateMask();
  }

  updateChangedModel(model: any): void {
    this.model = model;
  }

  private onSave(): void {
    if (this._originalValue != this.value) {
      this.updateModel();
      this.update.emit({ [this.fieldDef.name]: this.value });
    }
  }

  private updateModel(): void {
    this.model[this.fieldDef.name] = this.value;
    this._originalValue = this.value;
  }

  private updateMask(): void {
    if (this.fieldMask) {
      this.mask$.next(this.fieldMask(this.value));
    }
  }
}
